/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AdminPatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto
 */
export interface AdminPatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto {
    /**
     * 승인 여부
     * @type {boolean}
     * @memberof AdminPatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto
     */
    'isApproved'?: boolean | null;
    /**
     * 성별
     * @type {string}
     * @memberof AdminPatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto
     */
    'gender'?: AdminPatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDtoGenderEnum;
    /**
     * 나이
     * @type {number}
     * @memberof AdminPatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto
     */
    'age'?: number;
    /**
     * 관리자 체크 여부
     * @type {boolean}
     * @memberof AdminPatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDto
     */
    'isCheck'?: boolean;
}

export const AdminPatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDtoGenderEnum = {
    M: 'M',
    F: 'F',
    Unknown: 'unknown'
} as const;

export type AdminPatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDtoGenderEnum = typeof AdminPatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDtoGenderEnum[keyof typeof AdminPatchViewupSnsAccountByViewupSnsAccountUuidReqBodyDtoGenderEnum];


